// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-title h2 {
    margin: 0;
}

/* the optional line under the question (ConfirmationModal note) */
.confirmation-note {
    margin-top: -6px;
    font-size: 14px;
    color: #6b6577;
}
`, "",{"version":3,"sources":["webpack://./src/components/confirmationModal.css"],"names":[],"mappings":"AAAA;IACI,SAAS;AACb;;AAEA,kEAAkE;AAClE;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB","sourcesContent":[".modal-title h2 {\r\n    margin: 0;\r\n}\r\n\r\n/* the optional line under the question (ConfirmationModal note) */\r\n.confirmation-note {\r\n    margin-top: -6px;\r\n    font-size: 14px;\r\n    color: #6b6577;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
